import { IS_DEVELOPMENT } from '@/dashboard/constants/app';

const paddle_constants: {
  environment: 'production' | 'sandbox';
  token: string;
} = {
  environment: IS_DEVELOPMENT ? 'sandbox' : 'production',
  token: IS_DEVELOPMENT ? 'test_5a0bd5b988a068222fcc3112a63' : 'live_25c52f18b75cb20194138e93728',
};

export default paddle_constants;
